<template>
	<div>
		<div class="box-detail-delivery">
			<div class="box-map-delivery">
				<GmapMap :center="{lat:10, lng:10}" :zoom="7" map-type-id="terrain" style="width: 100%; height: 100%">
				</GmapMap>
				<div class="zoom-map-delivery">
					<v-btn small fab color="primary lighten-1" @click="switchMap">
						<v-icon color="white" v-if="!mapZoom">mdi-magnify-plus-outline</v-icon>
						<v-icon color="white" v-else>mdi-magnify-minus-outline</v-icon>
					</v-btn>
				</div>
			</div>
			<div class="list-detail-delivery white" v-if="!mapZoom">
				<v-col cols="12" class="px-3 pt-3 pb-0">
					<carousel :loop="false" :responsive="{0:{items:1},600:{items:2},1500:{items:3}}" :nav="false" :dots="false" :margin="8">
						<div class="pa-1" v-for="i in 5" :key="i">
							<v-card elevation="3" class="mb-1 content-detail-delivery">
								<v-col cols="12" class="pa-4 text-body-2">
									<div>Nomor Pengiriman</div>
									<div class="font-weight-bold">SDO0876546763</div>
								</v-col>
								<v-col cols="12" class="px-4 pb-4 pt-0 text-body-2">
									<v-row>
										<v-col cols="6" class="py-0 pr-0">
											<div>Tujuan</div>
											<div class="font-weight-bold">DI Yogyakarta</div>
										</v-col>
										<v-col cols="6" class="py-0 pl-0">
											<div>Penerima</div>
											<div class="font-weight-bold">Isa</div>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="px-4 pb-4 pt-0 text-body-2">
									<div>Alamat</div>
									<div class="font-weight-bold">Jl Mawar</div>
								</v-col>
								<v-col cols="12" class="px-4 pb-4 pt-0 text-body-2">
									<div>Jumlah Muatan</div>
									<div class="font-weight-bold">100</div>
								</v-col>
								<v-col cols="12" class="px-4 pb-4 pt-0 text-body-2">
									<div class="pb-2">Detail Muatan</div>
									<v-card elevation="3" class="rounded-lg mb-3" v-for="i in 2" :key="i">
										<div class="pa-2 d-flex">
											<v-img max-width="50" max-height="50" class="rounded-lg" src="/assets/produk/produk-milagros-water-ro-big.png"></v-img>
											<div class="my-auto pl-2">
												<div>Milagros Drinking Water</div>
												<div class="font-weight-bold">45</div>
											</div>
										</div>
									</v-card>
								</v-col>
							</v-card>
						</div>
					</carousel>
				</v-col>
			</div>
		</div>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
	components: {
		carousel
	},
	data () {
		return {
			mapZoom: false,
		}
	},
	methods: {
		switchMap() {
			this.mapZoom = !this.mapZoom
		}
	}
};
</script>